import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-brand-cream" data-id="element-66">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-67">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-68">
          <div className="max-w-2xl" data-id="element-69">
            <FadeIn data-id="element-70">
              <div className="w-12 h-[2px] bg-brand-gold mb-6" data-id="element-71"></div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-teal leading-tight mb-6" data-id="element-72">
                Detén el "Impuesto TDAH": Recupera el Dinero que tu Cerebro
                Pierde por Descuido
              </h1>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-73">
              <h2 className="text-xl md:text-2xl text-brand-gray font-serif italic mb-8" data-id="element-74">
                El sistema de rescate financiero diseñado para mujeres de 40+
                que están cansadas de pagar recargos, suscripciones olvidadas y
                compras por impulso.
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-75">
              <div className="space-y-4 text-brand-charcoal/80 text-lg mb-10" data-id="element-76">
                <p data-id="element-77">
                  Son las 11:00 PM. Abres tu aplicación bancaria y ahí está otra
                  vez: un cargo de $89 de una suscripción que juraste cancelar
                  hace meses. O peor, un recargo de $35 por un pago que "se te
                  pasó" a pesar de tener el dinero.
                </p>
                <p data-id="element-78">
                  No es falta de disciplina. No es que seas "mala con el
                  dinero". Es el <strong data-id="element-79">Impuesto TDAH</strong>: el costo real y
                  doloroso de vivir con un cerebro neuro divergente en un mundo
                  diseñado para personas lineales.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-80">
              <Button href="#offer" className="w-full sm:w-auto" data-id="element-81">
                Quiero Detener El Impuesto TDAH Ahora
              </Button>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} direction="left" className="relative lg:ml-auto" data-id="element-82">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-83">
              {/* Decorative background element */}
              <div className="absolute inset-0 bg-brand-teal/5 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-84"></div>
              <img src="https://cdn.magicpatterns.com/uploads/23yeoLuzsE8W6kM6kVSfPN/highend-ipad-pro.png" alt="El Kit de Emergencia en un iPad" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-85" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}